module.exports = __webpack_public_path__ + "static/media/Lille-riksvapen.c0ad62a4.png";